<div class="analytics-container py-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <div>
      <h2 class="fw-bold mb-0"><i class="bi bi-graph-up-arrow me-2 text-primary"></i>Centro de Mando ServiTrack</h2>
      <p class="text-muted mb-0">KPIs Operativos, Eficiencia y Marketing Accionable</p>
    </div>
    
    <!-- Filtro de Tiempo Dinámico -->
    <div class="bg-white p-1 rounded-pill shadow-sm border">
      <div class="btn-group" role="group">
        <button class="btn btn-sm rounded-pill px-3" [class.btn-primary]="selectedPeriod === 'day'" [class.text-muted]="selectedPeriod !== 'day'" (click)="setPeriod('day')">Hoy</button>
        <button class="btn btn-sm rounded-pill px-3" [class.btn-primary]="selectedPeriod === 'week'" [class.text-muted]="selectedPeriod !== 'week'" (click)="setPeriod('week')">Semana</button>
        <button class="btn btn-sm rounded-pill px-3" [class.btn-primary]="selectedPeriod === 'month'" [class.text-muted]="selectedPeriod !== 'month'" (click)="setPeriod('month')">Mes</button>
        <button class="btn btn-sm rounded-pill px-3" [class.btn-primary]="selectedPeriod === 'quarter'" [class.text-muted]="selectedPeriod !== 'quarter'" (click)="setPeriod('quarter')">Trimestre</button>
        <button class="btn btn-sm rounded-pill px-3" [class.btn-primary]="selectedPeriod === 'year'" [class.text-muted]="selectedPeriod !== 'year'" (click)="setPeriod('year')">Año</button>
        <button class="btn btn-sm rounded-pill px-3" [class.btn-primary]="selectedPeriod === 'all'" [class.text-muted]="selectedPeriod !== 'all'" (click)="setPeriod('all')">Histórico</button>
      </div>
    </div>
  </div>

  <div *ngIf="isLoading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status"></div>
    <p class="mt-3 text-muted italic">Procesando volúmenes de datos...</p>
  </div>

  <div *ngIf="!isLoading">
    <!-- Fila 1: KPIs Principales (Sensibles al filtro de tiempo) -->
    <div class="row g-3 mb-4">
      <div class="col-md-3">
        <div class="kpi-card shadow-sm border-0 card p-3 h-100 border-start border-success border-4">
          <small class="text-muted text-uppercase fw-bold">Facturación Bruta</small>
          <h3 class="mb-0 text-success fw-bold">{{ totalRevenue | currency:'DOP':'RD$' }}</h3>
          <div class="mt-2 small text-muted">Total de {{ totalJobs }} órdenes en el periodo</div>
        </div>
      </div>

      <div class="col-md-3">
        <div class="kpi-card shadow-sm border-0 card p-3 h-100">
          <small class="text-muted text-uppercase fw-bold">Ticket Promedio</small>
          <h3 class="mb-0 text-primary fw-bold">{{ avgTicket | currency:'DOP':'RD$' }}</h3>
          <div class="mt-2 small text-muted text-truncate">Gasto promedio por visita</div>
        </div>
      </div>

      <!-- Eficiencia de Entrega -->
      <div class="col-md-3">
        <div class="kpi-card shadow-sm border-0 card p-3 h-100">
          <div class="d-flex justify-content-between align-items-start">
            <small class="text-muted text-uppercase fw-bold">Tiempo Promedio</small>
            <i class="bi" [ngClass]="avgDaysToCompletePeriod <= avgDaysToCompleteHistory ? 'bi-arrow-down-short text-success fs-4' : 'bi-arrow-up-short text-danger fs-4'"></i>
          </div>
          <h3 class="mb-0 fw-bold" [ngClass]="avgDaysToCompletePeriod <= avgDaysToCompleteHistory ? 'text-success' : 'text-danger'">
            {{ avgDaysToCompletePeriod | number:'1.1-1' }} <small class="fs-6">días</small>
          </h3>
          <div class="mt-1 small text-muted border-top pt-1">Meta Global: {{ avgDaysToCompleteHistory | number:'1.1-1' }}d</div>
        </div>
      </div>

      <!-- NUEVO: Efectividad (% Entregado a Tiempo) -->
       <!-- NUEVO: Efectividad (% Entregado a Tiempo) -->
      <div class="col-md-3">
        <div class="kpi-card shadow-sm border-0 card p-3 h-100">
          <div class="d-flex justify-content-between align-items-start">
            <small class="text-muted text-uppercase fw-bold">Efectividad Operativa (3 dias)</small>
            <i class="bi" [ngClass]="effectivenessPeriod >= effectivenessHistory ? 'bi-graph-up-arrow text-success' : 'bi-graph-down-arrow text-danger'"></i>
          </div>
          <h3 class="mb-0 fw-bold" [ngClass]="effectivenessPeriod >= effectivenessHistory ? 'text-success' : 'text-danger'">
            {{ effectivenessPeriod | number:'1.0-0' }}% 
          </h3>
          <div class="small fw-medium" [ngClass]="effectivenessPeriod >= effectivenessHistory ? 'text-success' : 'text-danger'">
            {{ effectiveJobsPeriodCount }} de {{ compCountPeriodCount }} a tiempo
          </div>
          <div class="mt-1 small text-muted border-top pt-1">Historico: {{ effectivenessHistory | number:'1.0-0' }}% ({{ effectiveJobsHistoryCount }}/{{ compCountHistoryCount }})</div>
        </div>
      </div>
    </div>

    <!-- Fila 2: Clientes y Acciones Marketing -->
    <div class="row g-3 mb-4">
      <!-- Clientes Nuevos -->
      <div class="col-md-4">
        <div class="card shadow-sm border-0 bg-white p-3 h-100">
          <h6 class="text-muted text-uppercase fw-bold mb-3">Nuevos Clientes</h6>
          <div class="d-flex align-items-center">
            <div class="icon-circle bg-primary-subtle text-primary me-3 p-3 rounded-circle">
              <i class="bi bi-person-plus-fill fs-3"></i>
            </div>
            <div>
              <h2 class="mb-0 fw-bold">{{ newClientsPeriod }}</h2>
              <small class="text-muted">Adquiridos en este periodo</small>
            </div>
          </div>
        </div>
      </div>

      <!-- Acción: Inactivos (> 90 Días) -->
      <div class="col-md-4">
        <div class="card shadow-sm border-0 bg-dark text-white p-3 h-100 action-card" data-bs-toggle="modal" data-bs-target="#inactiveModal">
          <small class="text-warning fw-bold">INACTIVOS (> 90 DÍAS)</small>
          <div class="d-flex justify-content-between align-items-end mt-2">
            <h2 class="mb-0 fw-bold text-warning">{{ inactiveClientsList.length }}</h2>
            <i class="bi bi-send-fill fs-4 text-warning"></i>
          </div>
          <small class="text-light-50 mt-1">Clic para contactar y recuperar</small>
        </div>
      </div>

      <!-- Acción: Nunca / > 60 Días sin Full -->
      <div class="col-md-4">
        <div class="card shadow-sm border-0 bg-white border-dashed p-3 h-100 action-card border-primary" data-bs-toggle="modal" data-bs-target="#noFullModal">
          <small class="text-primary fw-bold">ALERTA SERVICIO FULL (> 60 DÍAS)</small>
          <div class="d-flex justify-content-between align-items-end mt-2">
            <h2 class="mb-0 fw-bold text-primary">{{ noFullServiceClientsList.length }}</h2>
            <i class="bi bi-bullseye fs-4 text-primary"></i>
          </div>
          <small class="text-muted mt-1">Clic para sugerir mantenimiento profundo</small>
        </div>
      </div>
    </div>

    <!-- Fila 3: Gráficas (Sensibles al periodo) -->
    <div class="row g-4 mb-4">
      <div class="col-lg-8">
        <div class="card shadow-sm border-0 p-3 h-100">
          <h5 class="fw-bold mb-3">Volumen de Trabajo (Tendencia)</h5>
          <div class="chart-container" style="position: relative; height:320px;">
            <canvas #intakeChart></canvas>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="card shadow-sm border-0 p-3 h-100">
          <h5 class="fw-bold mb-3">Ingresos por Servicio</h5>
          <div class="chart-container" style="position: relative; height:320px;">
            <canvas #revenueChart></canvas>
          </div>
        </div>
      </div>
    </div>

    <!-- Fila 4: Rankings Históricos Globales -->
    <div class="row g-4">
      <!-- Ranking por Facturación -->
      <div class="col-md-6">
        <div class="card shadow-sm border-0">
          <div class="card-header bg-white py-3 border-0">
            <h6 class="mb-0 fw-bold">Top 5 Clientes (Facturación Histórica)</h6>
          </div>
          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table table-hover align-middle mb-0">
                <thead class="bg-light">
                  <tr class="small text-muted"><th class="ps-3">CLIENTE</th><th class="text-end pe-3">TOTAL GENERADO</th></tr>
                </thead>
                <tbody>
                  <tr *ngFor="let c of topClientsByRevenue">
                    <td class="ps-3">
                      <div class="fw-bold">{{ c.name }}</div>
                      <div class="small text-muted">{{ c.volume }} trabajos realizados</div>
                    </td>
                    <td class="text-end pe-3 text-success fw-bold">{{ c.revenue | currency:'DOP':'RD$' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Ranking por Frecuencia -->
      <div class="col-md-6">
        <div class="card shadow-sm border-0">
          <div class="card-header bg-white py-3 border-0">
            <h6 class="mb-0 fw-bold">Top 5 Clientes (Visitas Históricas)</h6>
          </div>
          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table table-hover align-middle mb-0">
                <thead class="bg-light">
                  <tr class="small text-muted"><th class="ps-3">CLIENTE</th><th class="text-end pe-3">VISITAS AL TALLER</th></tr>
                </thead>
                <tbody>
                  <tr *ngFor="let c of topClientsByVolume">
                    <td class="ps-3 fw-bold">{{ c.name }}</td>
                    <td class="text-end pe-3"><span class="badge bg-primary rounded-pill px-3">{{ c.volume }} órdenes</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  
  </div>

  <!-- MODAL: CLIENTES INACTIVOS (> 90 Días) -->
  <div class="modal fade" id="inactiveModal" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-dark text-white">
          <h5 class="modal-title"><i class="bi bi-exclamation-triangle-fill text-warning me-2"></i>Recuperación: > 90 días inactivos</h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body p-0">
          <div class="p-3 bg-light d-flex justify-content-between align-items-center">
            <span>Objetivos: <strong>{{ inactiveClientsList.length }} clientes</strong></span>
            <button class="btn btn-sm btn-dark rounded-pill px-3" (click)="sendMassEmail('inactivo')">
              <i class="bi bi-envelope-fill me-1"></i> Email Masivo
            </button>
          </div>
          <div class="table-responsive" style="max-height: 400px;">
            <table class="table table-hover mb-0 align-middle">
              <thead class="sticky-top bg-white">
                <tr class="small text-muted"><th>CLIENTE</th><th>ÚLTIMA VISITA</th><th class="text-center">ACCIÓN</th></tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of inactiveClientsList">
                  <td>
                    <div class="fw-bold">{{ row.client.name }}</div>
                    <small class="text-muted">{{ row.client.phone || 'Sin tel.' }}</small>
                  </td>
                  <td>
                    <span class="text-danger fw-bold">Hace {{ row.days }} días</span>
                    <div class="small text-muted">{{ row.date | date:'dd MMM yyyy' }}</div>
                  </td>
                  <td class="text-center">
                    <button class="btn btn-outline-success btn-sm rounded-circle shadow-sm" title="Escribir WhatsApp" (click)="sendWhatsapp(row.client, 'inactivo', row.days)">
                      <i class="bi bi-whatsapp"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- MODAL: NUNCA / > 60 DÍAS 'FULL' -->
  <div class="modal fade" id="noFullModal" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white">
          <h5 class="modal-title"><i class="bi bi-bullseye me-2"></i>Up-Selling: Servicio Full (> 60 Días)</h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body p-0">
          <div class="p-3 bg-light d-flex justify-content-between align-items-center">
            <span>Oportunidades: <strong>{{ noFullServiceClientsList.length }} clientes</strong></span>
            <button class="btn btn-sm btn-primary rounded-pill px-3" (click)="sendMassEmail('no-full')">
              <i class="bi bi-envelope-fill me-1"></i> Email Masivo
            </button>
          </div>
          <div class="table-responsive" style="max-height: 400px;">
            <table class="table table-hover mb-0 align-middle">
              <thead class="sticky-top bg-white">
                <tr class="small text-muted"><th>CLIENTE</th><th>ÚLTIMO SERVICIO FULL</th><th class="text-center">ACCIÓN</th></tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of noFullServiceClientsList">
                  <td>
                    <div class="fw-bold">{{ row.client.name }}</div>
                    <small class="text-muted">{{ row.client.phone || 'Sin tel.' }}</small>
                  </td>
                  <td>
                    <div *ngIf="row.days === null">
                      <span class="badge bg-secondary-subtle text-secondary border">Nunca ha hecho Full</span>
                    </div>
                    <div *ngIf="row.days !== null">
                      <span class="text-primary fw-bold">Hace {{ row.days }} días</span>
                      <div class="small text-muted">{{ row.date | date:'dd MMM yyyy' }}</div>
                    </div>
                  </td>
                  <td class="text-center">
                    <button class="btn btn-outline-success btn-sm rounded-circle shadow-sm" title="Sugerir por WhatsApp" (click)="sendWhatsapp(row.client, 'no-full', row.days)">
                      <i class="bi bi-whatsapp"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>